import { useState } from 'react';

import { useCreatePreSignedUrl } from '../query/file';

const useImage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { mutateAsync: createPreSignedUrl } = useCreatePreSignedUrl();

  /**
   * 파일 리사이즈 후 S3 업로드까지 처리하여 최종 public URL 반환
   */
  const resizeAndUpload = async (file: File, prefix: string): Promise<string | null> => {
    setLoading(true);
    setError(null);

    try {
      // 1. Resize
      const formData = new FormData();
      formData.append('file', file);

      const resizeRes = await fetch('/resize', {
        method: 'POST',
        body: formData,
      });

      if (!resizeRes.ok) {
        const err = await resizeRes.json();
        setError(err.error || 'Resize failed');
        return null;
      }

      const resizedBlob = await resizeRes.blob();

      const resizedFile = new File([resizedBlob], file.name.replace(/\.\w+$/, '.webp'), {
        type: 'image/webp',
      });

      const presignedRes = await createPreSignedUrl({
        prefix: prefix,
        contentType: 'image/webp',
      });

      if (!presignedRes.data) return null;

      const { preSignedUrl, key } = presignedRes.data;

      const response = await fetch(preSignedUrl, {
        method: 'PUT',
        body: resizedFile,
        headers: {
          'Content-Type': 'image/webp',
        },
      });

      if (!response.ok) {
        throw new Error('S3 upload failed');
      }

      const publicUrl = `https://questophia-image.s3.ap-northeast-2.amazonaws.com/${key}`;
      return publicUrl;
    } catch (err) {
      console.error(err);
      setError('Upload failed');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    resizeAndUpload,
    loading,
    error,
  };
};

export default useImage;
